import { render, staticRenderFns } from "./_otp.vue?vue&type=template&id=162b856b&scoped=true&lang=pug&"
import script from "./_otp.vue?vue&type=script&lang=js&"
export * from "./_otp.vue?vue&type=script&lang=js&"
import style0 from "./_otp.vue?vue&type=style&index=0&id=162b856b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "162b856b",
  null
  
)

export default component.exports